import weeklysale01 from "@/assets/image/weeklysale01.webp";
import weeklysale02 from "@/assets/image/weeklysale02.webp";
import weeklysale03 from "@/assets/image/weeklysale03.webp";

const weeklySaleData = [
  {
    image: weeklysale01,
    alt: "코코아 게스트하우스",
    name: "코코아 게스트하우스",
    salePrice: "70%",
    price: "35,000원~",
  },
  {
    image: weeklysale02,
    alt: "해운대 Y 게스트하우스",
    name: "해운대 Y 게스트하우스",
    salePrice: "55%",
    price: "25,000원~",
  },
  {
    image: weeklysale03,
    alt: "ABC 홈스테이",
    name: "ABC 홈스테이",
    salePrice: "35%",
    price: "35,000원",
  },
  // 임시 데이터 3개 추가
  {
    image: weeklysale01,
    alt: "코코아 게스트하우스",
    name: "코코아 게스트하우스",
    salePrice: "70%",
    price: "35,000원~",
  },
  {
    image: weeklysale02,
    alt: "해운대 Y 게스트하우스",
    name: "해운대 Y 게스트하우스",
    salePrice: "55%",
    price: "25,000원~",
  },
  {
    image: weeklysale03,
    alt: "ABC 홈스테이",
    name: "ABC 홈스테이",
    salePrice: "35%",
    price: "35,000원",
  },
];

export default weeklySaleData;
